export default { sha: 'c2e47c8e83d0ed5ef4035495bfb6b967467f30b6', buildNumber: 'undefined' }
